import React from 'react';
import { Icon, StandAloneLink } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import Classes from './BusinessSellerBuyNowInfo.module.scss';

interface IBusinessSellerBuyNowInfoProps {
  sellerId: number;
}

export const BusinessSellerBuyNowInfo = ({ sellerId }: IBusinessSellerBuyNowInfoProps) => {
  const { t } = useI18nContext();
  const termsAndConditionsUrl = `/smb-profile/profile/${sellerId}/terms-and-conditions`;

  return (
    <div className={Classes.container}>
      <div className={Classes.protectionContainer}>
        <Icon name="veilig-handelen" color="background-info-default" />
        <span className={Classes.infoLabel}>{t('businessSeller.buyerProtection')}</span>
      </div>
      <div className={Classes.reflectionPeriodContainer}>
        <Icon name="warranty" color="background-info-default" />
        <span className={Classes.infoLabel}>{t('businessSeller.reflectionPeriod')}</span>
      </div>
      <div className={Classes.termsAndConditionsLinkContainer}>
        <StandAloneLink href={termsAndConditionsUrl} iconLeft="shop" className={Classes.termsAndConditionsLink}>
          {t('businessSeller.termsAndConditions')}
        </StandAloneLink>
      </div>
    </div>
  );
};
